import { Card } from 'react-bootstrap';

import StandingInstructionTable from './StandingInstructionTable';

const StandingInstruction = () => {
  return <StandingInstructionTable />;
};

export default StandingInstruction;
